import { render, staticRenderFns } from "./menus.vue?vue&type=template&id=ebd35942&scoped=true&lang=pug"
import script from "./menus.vue?vue&type=script&lang=coffee"
export * from "./menus.vue?vue&type=script&lang=coffee"
import style0 from "./menus.vue?vue&type=style&index=0&id=ebd35942&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebd35942",
  null
  
)

export default component.exports